import { defineValidationRules } from './forms/validation-rules';

export default {
  install: () => {
    defineValidationRules();
  },
};
